import ButtonLink from '../../general/ButtonLink'
import Button from '../../general/Button'
import ImageWithFallback from '../../general/ImageWithFallback'
import Translation from '../../Translation/cont/Translation'

const ListItem = ({
    title = false,
    titleTransId = false,
    styles=false,
    showImage = false,
    imageSrc = false,
    imageSrcFallback = false,
    type = false, 
    additionalClass  = false, 
    isSelected = false,
    itemId=null,
    isInApp= false,
    hasDisplayTimes = false,
    basePreviewUrl =false,
    isOutOfRange = false,
    additionalButton='',
    pathnameEdit = false,
    onDelete = false
}) => {
    let wrapperClass = "item-poster-format cursor-pointer"

    if(additionalClass) {
        wrapperClass += ' ' + additionalClass
    }

    if(type) {
        wrapperClass += ' ' + type
    }

    if(isSelected) {
        wrapperClass += ' is-selected' 
    }

    if(isInApp) {
        wrapperClass += ' show-in-app-active'
    }

    if(hasDisplayTimes) {
        wrapperClass += ' has-display-times'
    }

    if(isOutOfRange) {
        wrapperClass += ' out-of-range'
    }

    return (
        <div className={wrapperClass}>
      
            {(styles || showImage) && <div className={"item-image"} style={styles ? styles : undefined}>
                {imageSrc && <ImageWithFallback
                    src={imageSrc}
                    srcFallback={imageSrcFallback}
                />}
            </div>}

            {(title || titleTransId) && <div className="item-title-wrapper">
                {titleTransId ? (
                    <h4 className="item-title text-xsmall-light"><Translation id={titleTransId}/></h4>
                ) : (
                    <h4 className="item-title text-xsmall-light" dangerouslySetInnerHTML={{ __html: title}}></h4>
                )}
            </div>}

            {additionalButton}
    
            {(pathnameEdit && !basePreviewUrl) && <ButtonLink
                pathname={pathnameEdit}
                className="button button-edit"
                transId="edit_button"
            />}
    
            {basePreviewUrl && itemId && <ButtonLink
                pathname={basePreviewUrl + itemId}
                target={'_blank'}
                outOfRouting={true}
                className="button button-preview"
                transId="button_preview"
            />}

            {onDelete && <Button
                className="button button-delete-item"
                transId="remove_button"
                onClick={onDelete}
            />}

            {isInApp && <div className='show-in-app-icon'>
                <span className='screen-reader-text'>Show In App Active</span>
            </div>}
        </div>
    )
}

export default ListItem